import { AsyncPipe, NgClass } from '@angular/common';
import {
    afterNextRender,
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    ElementRef,
    inject,
    viewChild,
} from '@angular/core';
import { LayerService } from './layer.service';

@Component({
    selector: 'interacta-layer',
    templateUrl: './layer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, NgClass],
})
export class LayerComponent {
    readonly layerService = inject(LayerService);
    private readonly layerEl =
        viewChild.required<ElementRef<HTMLElement>>('layer');

    constructor() {
        const destroyRef = inject(DestroyRef);

        afterNextRender(() => {
            const el = this.layerEl().nativeElement;
            this.layerService.registerElement(el);
            // The element is captured here: viewChild is no longer readable
            // once the view is destroyed.
            destroyRef.onDestroy(() => this.layerService.unregisterElement(el));
        });
    }
}
